import type { IconButtonProps } from '@mui/material/IconButton';

import { m } from 'framer-motion';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { usePopover } from 'minimal-shared/hooks';

import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { Avatar, Divider, Typography } from '@mui/material';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { userFunc } from 'src/context/user/user';
import { useAppDispatch } from 'src/context/store';
import { removeUser } from 'src/context/auth/auth';

import { Iconify } from 'src/components/iconify';
import { CustomPopover } from 'src/components/custom-popover';
import { varTap, varHover, transitionTap } from 'src/components/animate';

// ----------------------------------------------------------------------

export type UserPopoverProps = IconButtonProps & {
  data?: {
    value: string;
    label: string;
    countryCode: string;
  }[];
};

export function UserPopover({ data = [], sx, ...other }: UserPopoverProps) {
  const { open, anchorEl, onClose, onOpen } = usePopover();
  const dispatch = useAppDispatch();
  const router = useRouter();
  const user = useSelector((state: any) => state.user);
  const [userData, setUserData] = useState([] as any);

  useEffect(() => {
    if (dispatch) {
      dispatch(
        userFunc({
          userId: null,
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    const userDatas = user?.userData;

    setUserData(userDatas);
  }, [user]);

  const renderMenuList = () => (
    <CustomPopover open={open} anchorEl={anchorEl} onClose={onClose}>
      <MenuList sx={{ width: 160, minHeight: 72 }}>
        <MenuItem
          onClick={() => {
            router.push(paths.profile);
            onClose();
          }}
        >
          <Avatar src={userData?.personalInformation?.profileImageUrl ?? ''} />
          <Typography variant="body2" fontWeight={700}>
            {userData?.personalInformation?.name ?? ''}{' '}
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            router.push(paths.profile);
            onClose();
          }}
        >
          <Iconify icon="solar:user-linear" width={20} />
          <Typography variant="body2" fontWeight={500}>
            Profilim
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            router.push(paths.favorites);
            onClose();
          }}
        >
          <Iconify icon="icon-park-outline:like" width={20} />
          <Typography variant="body2" fontWeight={500}>
            Favoriler
          </Typography>
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            router.push(paths.myActivities);
            onClose();
          }}
        >
          <Iconify icon="ic:baseline-event" width={20} />
          <Typography variant="body2" fontWeight={500}>
            Etkinliklerim
          </Typography>
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            router.push(paths.messages);
            onClose();
          }}
        >
          <Iconify icon="tabler:message" width={20} />
          <Typography variant="body2" fontWeight={500}>
            Sorularım
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            router.push(paths.settings);
            onClose();
          }}
        >
          <Iconify icon="uil:setting" width={20} />
          <Typography variant="body2" fontWeight={500}>
            Ayarlar
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            dispatch(removeUser());
            window.location.href = '/';
          }}
        >
          <Iconify icon="ci:exit" width={20} sx={{ color: 'error.main' }} />
          <Typography variant="body2" fontWeight={500} sx={{ color: 'error.main' }}>
            Çıkış Yap
          </Typography>
        </MenuItem>
      </MenuList>
    </CustomPopover>
  );

  return (
    <>
      <IconButton
        component={m.button}
        whileTap={varTap(0.96)}
        whileHover={varHover(1.04)}
        transition={transitionTap()}
        aria-label="Languages button"
        onClick={onOpen}
        sx={[
          (theme) => ({
            p: 0,
            width: 40,
            height: 40,
            outline: '2px solid',
            outlineColor: 'common.white',
            ...(open && { bgcolor: theme.vars.palette.action.selected }),
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...other}
      >
        <Avatar src={userData?.personalInformation?.profileImageUrl ?? ''} />
      </IconButton>

      {renderMenuList()}
    </>
  );
}
